module.exports = __webpack_public_path__ + "static/media/textarea.1c1ddc4e.svg";